import React, { ReactNode } from "react";
import "./Modal.css";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-bg">
      <div className="modal-container">
        <div>
          <button onClick={onClose} className="modal-close">
            x
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
